// api.js — amm-v3 (A1, ondata 28): parte PURA della vista Cruscotto, testabile
// sotto node (contract test server/src/lib/amm-v3-cruscotto.test.js).
//
// PRINCIPI (rito proc-v3/f23h, adattato ad AMM — spike o27 §2.2/§2.3):
//  - TESTI VERBATIM dal v1 (admin-module.js, renderCruscotto r.1239-1344 +
//    bulk barra r.1175-1220 + ricerca globale r.1358-1476): il contract test
//    pinna OGNI stringa di AM_TEXTS sul sorgente v1 — il drift fa ROSSO.
//  - FORMULE del v1 replicate come funzioni pure (filtri, responsabili,
//    payload bulk CAS, testi d'esito): stessa semantica, stessi quirk.
//  - DELEGHE alle primitive v1 (mai reimplementate): modale scadenza
//    (AMM.openEditor), navigazione della ricerca globale (AMM.ricercaGoto),
//    formattazioni e badge (AMM.eur/urgency/areaBadge/…), toast (AMM.toast).
//    admin-module.js resta OFF-LIMITS: zero byte cambiati lì.
//  - MAI 'nav:badge' o canali nuovi da client/src/amm-v3/** (asserito dai test).

// ---- metodi di window.AMM che il v3 DELEGA (guardie: senza uno solo di
// questi la vista sarebbe monca ⇒ install inerte, mondo v1 intatto) ----
export const AMM_DELEGATED_METHODS = [
  'renderPage',            // il seam stesso (wrap) + refresh post-azione
  'renderCruscotto',       // la vista v1 wrappata (drift guard: rename ⇒ rosso)
  'openEditor',            // modale scadenza (click riga, + Scadenza) — resta v1
  'ricercaGoto',           // navigazione dei risultati della ricerca globale
  'toast',                 // conferme visibili (stesso canale del v1)
  'isAdmin',               // bottone bulk "Segna pagate" solo admin (parità F15-T3)
  'eur',                   // formattazione € (unica fonte: v1)
  'urgency',               // {b, pill:[bg,fg,label]} per riga (unica fonte: v1)
  'isScaduta',             // filtro "Solo scadute" (stessa condizione del pill)
  'scadPagabile',          // checkbox bulk solo su righe pagabili (parità A5-042)
  'esc',                   // escaping nelle stringhe HTML delegate
  'areaBadge',             // badge area (HTML v1, iniettato verbatim)
  'slittamentoBadge',      // chip "slittata dal gg/mm" (HTML v1)
  'promemoriaSnoozeBadge', // chip "promemoria posticipato al gg/mm" (HTML v1)
  'responsabileBadge',     // chip responsabile (HTML v1)
];

// ---- funzioni di window.api.amm usate dal v3 (path puntati, stessa API del
// v1: nessun endpoint nuovo) ----
export const AMM_API_PATHS = [
  'dashboard',             // GET /amm/dashboard — counts + lista (fonte unica)
  'promemoria.stato',      // banner promemoria dormienti (A3-077)
  'scadenze.rigenera',     // bottone Rigenera
  'scadenze.bulkPagate',   // bulk "Segna pagate" (lock B6 per riga)
  'export.download',       // Esporta CSV
  'ricerca',               // ricerca globale (9 sorgenti)
];

export function apiPathFn(win, dottedPath) {
  let o = win && win.api && win.api.amm;
  for (const k of dottedPath.split('.')) o = o ? o[k] : undefined;
  return typeof o === 'function' ? o : null;
}

// ---- TESTI VERBATIM dal v1 (pinnati dal contract test sul sorgente) ----
export const AM_TEXTS = {
  title: 'Cruscotto scadenze',
  oggi: 'oggi ',
  exportCsv: 'Esporta CSV',
  rigenera: 'Rigenera',
  nuovaScadenza: '+ Scadenza',
  kpiScadute: 'Scadute',
  kpiEntro7: 'Entro 7 giorni',
  kpiEntro30: 'Entro 30 giorni',
  kpiDaPagare: 'Da pagare',
  tutteLeAree: 'Tutte le aree',
  soloScadute: 'Solo scadute',
  tuttiIResponsabili: 'Tutti i responsabili',
  inScadenza: 'In scadenza',
  emptyBase: 'Nessuna scadenza imminente',
  emptyFiltro: ' per il filtro selezionato',
  searchPlaceholder: 'Cerca scadenze, dipendenti, veicoli, F24…',
  searchNessunRisultato: 'Nessun risultato per "',
  searchErrore: 'Ricerca non riuscita: ',
  annullaSelezione: 'Annulla selezione',
  segnaPagate: 'Segna pagate (',
  totale: ' · totale ',
  toastRigenerato: 'Scadenzario rigenerato',
  toastExportFallito: 'Export fallito: ',
  alertBulkPrefix: 'Operazione NON riuscita: ',
  alertBulkSuffix: ' — nessuna scadenza è stata modificata.',
  bannerPromemoria: 'I promemoria email non sono attivi — attivali dal Profilo',
  bannerVaiProfilo: 'Vai al Profilo',
  bannerChiudi: 'Chiudi',
  dismissPrefix: 'amm_promemoria_banner_dismesso_',
  archiviatoBadge: 'archiviato',
};

// Testi NUOVI del v3, dichiarati (il v1 non ha intestazioni di colonna: la
// lista è a righe libere; il DataTable del design system le richiede —
// stesso precedente dichiarato di email-v3 E3, deviazione 6).
export const AM_NEW_TEXTS = {
  colData: 'Data',
  colScadenza: 'Scadenza',
  colImporto: 'Importo',
  colStato: 'Stato',
  attendere: 'Attendere…', // parità col busy() v1 (r.873): stessa etichetta
  // D-A1.3 (deviazione dichiarata): nel v1 un errore su Rigenera resta MUTO
  // (await senza catch, r.1305-1307: unhandled rejection in console e basta).
  // Nel v3 l'errore si dichiara a toast — rete KO mai silenziosa (regole UI 3).
  rigeneraFallito: 'Rigenera non riuscito: ',
  // D-A1.5 (deviazione dichiarata, TROVATA DAL COLLAUDO a1-03): a ricarica
  // fallita con righe già a schermo il DataTable CONSERVA le righe (precedenza
  // 'righe presenti ⇒ data', design system) — ma senza un banner l'errore
  // sarebbe MUTO. Il v3 mostra un banner rumoroso con Riprova; il v1 in questo
  // caso SOSTITUISCE l'intera pagina con 'Errore: …' perdendo di vista i dati.
  erroreRicarica: 'Dati non aggiornati: ',
  riprova: 'Riprova',
};

// aree del filtro chip — VERBATIM v1 r.1248 (A3-033: assicurazione/documento
// sono i valori area REALI del motore)
export const AREE = ['tutte', 'fiscale', 'veicolo', 'assicurazione', 'documento', 'dipendente', 'sicurezza', 'atto'];

// colori KPI — VERBATIM v1 r.1280-1283
export const KPI_COLORS = { scadute: '#e11d48', entro7: '#d97706', entro30: '#0e7490', daPagare: '#0f172a' };

// ---- FORMULE v1 replicate (pure) ----

// filtro righe del Cruscotto — replica ESATTA di `shown` (v1 r.1262-1267).
// isScaduta arriva per parametro (a runtime: delega ad AMM.isScaduta — stessa
// condizione del pill 'scaduto', A5-043/A3-075).
export function filtraScadenze(lista, f, isScaduta) {
  const filt = f.area;
  const soloScadute = !!f.soloScadute;
  const filtResp = f.responsabile || '';
  return (lista || []).filter((s) => {
    if (filt !== 'tutte' && s.area !== filt) return false;
    if (soloScadute && !isScaduta(s)) return false;
    if (filtResp && s.responsabile !== filtResp) return false;
    return true;
  });
}

// valori distinti di responsabile PRESENTI nei dati (v1 r.1255, A4-098)
export function responsabiliDistinti(lista) {
  return Array.from(new Set((lista || []).map((s) => s.responsabile).filter(Boolean))).sort();
}

// se il responsabile filtrato è sparito dai dati il filtro torna 'tutti'
// (v1 r.1257 — mai una lista vuota senza spiegazione)
export function normalizzaResponsabile(filtResp, responsabili) {
  if (filtResp && responsabili.indexOf(filtResp) === -1) return '';
  return filtResp || '';
}

// messaggio vuoto — QUIRK v1 replicato (r.1303): il suffisso "per il filtro
// selezionato" appare per area/scadute ma NON per il filtro responsabile.
export function emptyMessage(f) {
  return AM_TEXTS.emptyBase + (f.soloScadute || f.area !== 'tutte' ? AM_TEXTS.emptyFiltro : '') + '.';
}

// totale € delle selezionate (v1 r.1183: importo_previsto null conta 0, mai NaN)
export function totaleSelezionate(selezionate) {
  return (selezionate || []).reduce((t, s) => t + (s.importo_previsto || 0), 0);
}

// payload bulk-pagate CON lock B6 per riga — PARITÀ BYTE v1 r.1204:
// array di {id, _updated_at_atteso: updated_at}
export function bulkIdsPayload(selezionate) {
  return (selezionate || []).map((s) => ({ id: s.id, _updated_at_atteso: s.updated_at }));
}

// testo barra bulk (v1 r.1188): "N scaden(za selezionata|ze selezionate) · totale € X"
export function bulkBarraTesto(n, eurTotale) {
  return n + ' scaden' + (n === 1 ? 'za selezionata' : 'ze selezionate') + AM_TEXTS.totale + eurTotale;
}

// conferma INFORMATA prima del bulk (v1 r.1203: N e totale € PRIMA di confermare)
export function bulkConfirmTesto(n, eurTotale) {
  return 'Segnare come pagate ' + n + ' scaden' + (n === 1 ? 'za' : 'ze') + ' per un totale di ' + eurTotale + '?';
}

// esito bulk → testo toast (v1 r.1208-1214: esito ONESTO e parziale, mai un
// successo silenzioso se qualcosa è stato saltato)
export function bulkEsitoToast(esito) {
  if (esito.saltate && esito.saltate.length) {
    return esito.aggiornate + ' pagate, ' + esito.saltate.length + ' saltate ('
      + esito.saltate.map((x) => x.motivo).join(', ') + ')';
  }
  return esito.aggiornate + (esito.aggiornate === 1 ? ' scadenza segnata come pagata' : ' scadenze segnate come pagate');
}

export function bulkAlertTesto(msg) {
  return AM_TEXTS.alertBulkPrefix + msg + AM_TEXTS.alertBulkSuffix;
}

// chiave di dismiss del banner promemoria (v1 r.1230: include lo stato, così
// si resetta da sola se il promemoria torna dormiente dopo essere stato attivo)
export function dismissKey(stato) {
  return AM_TEXTS.dismissPrefix + (stato && stato.attivo ? '1' : '0') + '_' + (stato && stato.email ? '1' : '0');
}

// visibilità del banner (v1 r.1229-1231: configurato ⇒ mai; dismesso ⇒ mai)
export function bannerVisibile(stato, getItem) {
  if (!stato || stato.configurato) return false;
  try { if (getItem(dismissKey(stato)) === '1') return false; } catch (e) { /* storage negato: banner visibile */ }
  return true;
}

// definizione KPI (v1 r.1280-1283: etichette, valori, colori, 'Da pagare' small)
export function kpiDefs(counts, eur) {
  const c = counts || {};
  return [
    { label: AM_TEXTS.kpiScadute, val: String(c.scadute || 0), color: KPI_COLORS.scadute, small: false },
    { label: AM_TEXTS.kpiEntro7, val: String(c.entro_7gg || 0), color: KPI_COLORS.entro7, small: false },
    { label: AM_TEXTS.kpiEntro30, val: String(c.entro_30gg || 0), color: KPI_COLORS.entro30, small: false },
    { label: AM_TEXTS.kpiDaPagare, val: eur(c.totale_da_pagare || 0), color: KPI_COLORS.daPagare, small: true },
  ];
}

// etichetta chip area (v1 r.1287: 'tutte' → 'Tutte le aree', altrimenti il valore)
export function areaChipLabel(a) {
  return a === 'tutte' ? AM_TEXTS.tutteLeAree : a;
}

// mesi brevi — VERBATIM v1 r.662 (colonna data della riga scadenza)
export const MESI = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

// cella data della riga (v1 scadRow r.1128+1139-1140: giorno numerico colorato
// dall'urgenza + mese breve; senza data '–' e mese vuoto)
export function giornoMese(dataScadenza) {
  const dd = dataScadenza ? new Date(dataScadenza + 'T00:00:00') : null;
  return { giorno: dd ? String(dd.getDate()) : '–', mese: dd ? MESI[dd.getMonth()] : '' };
}

// sottotitolo della riga (v1 r.1142: note, altrimenti 'periodo <periodo>')
export function notaRiga(s) {
  return s.note || (s.periodo ? 'periodo ' + s.periodo : '');
}

// ---- LETTURA dati (stessa composizione del v1 r.1240-1242: dashboard +
// promemoria.stato con catch → null, MAI bloccante) ----
export async function readCruscotto(win) {
  const d = await apiPathFn(win, 'dashboard').call(null);
  let promemoriaStato = null;
  try { promemoriaStato = await apiPathFn(win, 'promemoria.stato').call(null); } catch (e) { promemoriaStato = null; }
  return { counts: (d && d.counts) || {}, lista: (d && d.lista) || [], promemoriaStato };
}

// ---- DELEGHE alle primitive v1 (modali/navigazione/refresh) ----
export function apriEditor(win, rec) { win.AMM.openEditor(rec); }
export function apriNuovaScadenza(win) { win.AMM.openEditor({}); }
export function ricercaVai(win, tipo, id) { win.AMM.ricercaGoto(tipo, id); }
// refresh post-azione = STESSA via del v1 (renderPage(currentPage)): passa dal
// wrap ⇒ la vista v3 ricarica i dati; a fallback attivo ridipinge il v1.
export function refreshPagina(win) { return win.AMM.renderPage(win.AMM.currentPage); }
export function rigenera(win) { return apiPathFn(win, 'scadenze.rigenera').call(null); }
export function bulkPagate(win, ids) { return apiPathFn(win, 'scadenze.bulkPagate').call(null, ids); }
// export CSV — v1 r.1312: vista 'scadenze', anno corrente
export function esportaCsv(win) { return apiPathFn(win, 'export.download').call(null, 'scadenze', new Date().getFullYear()); }
export function ricerca(win, q) { return apiPathFn(win, 'ricerca').call(null, q); }
